import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    BigSmartLogs,
    CreateBigSmartLogsInput,
    UpdateBigSmartLogsInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class BigSmartLogsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listBigSmartLogs(): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listBigSmartLogs
                })
            ).data.listBigSmartLogs.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByOrderId(orderId: number): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByOrderId,
                    variables: {
                        orderId
                    }
                })
            ).data.BigSmartLogsByOrderId.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByPremiumOrderId(
        premiumOrderId: string
    ): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByPremiumOrderId,
                    variables: {
                        premiumOrderId
                    }
                })
            ).data.BigSmartLogsByPremiumOrderId.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByClientId(clientId: string): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByClientId,
                    variables: {
                        clientId
                    }
                })
            ).data.BigSmartLogsByClientId.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByCreatorEmail(
        creator_email: string
    ): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByCreatorEmail,
                    variables: {
                        creator_email
                    }
                })
            ).data.BigSmartLogsByCreatorEmail.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByTrackingBumber(
        tracking_number: string
    ): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByTrackingBumber,
                    variables: {
                        tracking_number
                    }
                })
            ).data.BigSmartLogsByTrackingBumber.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsByPurchaseOrderNumber(
        purchase_order_number: string
    ): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsByPurchaseOrderNumber,
                    variables: {
                        purchase_order_number
                    }
                })
            ).data.BigSmartLogsByPurchaseOrderNumber.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }
    async bigSmartLogsSentStatus(
        already_sent: string
    ): Promise<BigSmartLogs[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.BigSmartLogsSentStatus,
                    variables: {
                        already_sent
                    }
                })
            ).data.BigSmartLogsSentStatus.items;
            if (data) return data as BigSmartLogs[];
        } catch (error) {
            console.error('Error finding BigSmartLogs:', error);
            return null;
        }
    }

    async createBigSmartLogs(
        input: CreateBigSmartLogsInput
    ): Promise<BigSmartLogs> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createBigSmartLogs,
                    variables: {
                        input
                    }
                })
            ).data.createBigSmartLogs;
            if (date) return date as BigSmartLogs;
        } catch (error) {
            console.error('Error creating BigSmartLogs:', error);
            return null;
        }
    }
    async updateBigSmartLogs(
        input: UpdateBigSmartLogsInput
    ): Promise<BigSmartLogs> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateBigSmartLogs,
                    variables: {
                        input
                    }
                })
            ).data.updateBigSmartLogs;
            if (date) return date as BigSmartLogs;
        } catch (error) {
            console.error('Error updated BigSmartLogs:', error);
            return null;
        }
    }
}
